import { motion, AnimatePresence } from "framer-motion";
import { Eye, Hand, Ear, Coffee, Heart } from "lucide-react";

export const GROUND = [
  { icon: Eye, text: "Name 5 things you can see" },
  { icon: Hand, text: "Notice 4 things you can feel" },
  { icon: Ear, text: "Listen for 3 sounds" },
  { icon: Coffee, text: "Find 2 things you can smell" },
  { icon: Heart, text: "Name 1 thing you're grateful for" },
];

export function BreathCircle({ phase, count }) {
  return (
    <div className="flex items-center gap-5">
      <div className="relative w-24 h-24 flex items-center justify-center shrink-0">
        <motion.div className="absolute inset-0 rounded-full bg-amber-400/30" animate={{ scale: phase.scale }} transition={{ duration: phase.secs, ease: "easeInOut" }} />
        <motion.div className="absolute inset-3 rounded-full bg-amber-400/60" animate={{ scale: phase.scale }} transition={{ duration: phase.secs, ease: "easeInOut" }} />
        <span className="relative font-mono text-2xl font-bold" data-testid="panic-breath-count">{count}</span>
      </div>
      <div>
        <div className="font-display text-xl font-bold" data-testid="panic-breath-phase">{phase.label}</div>
        <p className="text-sm text-stone-300 mt-1">Box breathing: 4 in, 4 hold, 4 out, 4 hold. Follow the circle. A few rounds is enough.</p>
      </div>
    </div>
  );
}

function GroundStep({ g, index, checked, onToggle }) {
  const Icon = g.icon;
  return (
    <li>
      <button type="button" data-testid={`ground-step-${index}`} onClick={onToggle}
        className={`w-full flex items-center gap-2 text-left text-sm px-3 py-2 rounded-xl transition ${checked ? "bg-emerald-500/20 text-emerald-200 line-through" : "bg-white/5 hover:bg-white/10"}`}>
        <Icon className="w-4 h-4 shrink-0" /> {g.text}
      </button>
    </li>
  );
}

export function GroundingList({ done, onChange }) {
  const toggle = (i) => onChange(done.includes(i) ? done.filter((d) => d !== i) : [...done, i]);
  return (
    <div>
      <div className="text-[10px] font-bold uppercase tracking-widest text-stone-400 mb-2">Then, ground yourself — tap each as you go</div>
      <ul className="space-y-1.5">
        {GROUND.map((g, i) => <GroundStep key={g.text} g={g} index={i} checked={done.includes(i)} onToggle={() => toggle(i)} />)}
      </ul>
      <AnimatePresence>
        {done.length === GROUND.length && (
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-sm text-emerald-200 mt-4" data-testid="panic-grounded-msg">
            You did it. This wave is passing. Log how you're feeling below whenever you're ready.
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
}

export function CrisisResources() {
  return (
    <div className="pt-3 border-t border-white/15 text-xs text-stone-300" data-testid="crisis-resources">
      <span className="font-semibold text-white">If you're in danger or thinking about harming yourself:</span> call or text{" "}
      <a href="tel:988" className="font-bold text-amber-300 hover:text-amber-200">988</a> (Suicide &amp; Crisis Lifeline, US, 24/7), text{" "}
      <span className="font-bold text-amber-300">HOME</span> to <span className="font-bold text-amber-300">741741</span>, or call <a href="tel:911" className="font-bold text-amber-300">911</a>. This app isn't a crisis service.
    </div>
  );
}
